import { FormControl, FormControlLabel, Grid, Radio, RadioGroup } from '@mui/material';

import TravelersNumberSelector from '~/components/Form/TravelersNumberSelector';

import { FlightType, TripTravellers } from '~/types/common';
import TravelClassSelector, { KeyDisplayOption } from './TravelClassSelector';

interface TripOptions {
  passengers: TripTravellers;
  type: FlightType;
  travelClass: string;
}
interface Props {
  tripOptions: TripOptions;
  onFlightTypeChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onAdultPassangersChange: (
    event:
      | React.FocusEvent<HTMLInputElement, Element>
      | React.PointerEvent<Element>
      | React.KeyboardEvent<Element>,
    value: number | null,
  ) => void;
  onChildrenPassangersChange: (
    event:
      | React.FocusEvent<HTMLInputElement, Element>
      | React.PointerEvent<Element>
      | React.KeyboardEvent<Element>,
    value: number | null,
  ) => void;
  onInfantPassangersChange: (
    event:
      | React.FocusEvent<HTMLInputElement, Element>
      | React.PointerEvent<Element>
      | React.KeyboardEvent<Element>,
    value: number | null,
  ) => void;
  onTravelClassChange: (value: string) => void;
}

function TravelersSelector({
  onAdultPassangersChange,
  onChildrenPassangersChange,
  onFlightTypeChange,
  onInfantPassangersChange,
  onTravelClassChange,
  tripOptions,
}: Props) {
  return (
    <Grid alignItems="center" container spacing={2}>
      <Grid item>
        <FormControl>
          <RadioGroup name="tripType" onChange={onFlightTypeChange} row value={tripOptions.type}>
            <FormControlLabel control={<Radio />} label="Return" value="return" />
            <FormControlLabel control={<Radio />} label="One Way" value="oneway" />
          </RadioGroup>
        </FormControl>
      </Grid>
      <Grid item>
        <TravelClassSelector
          onSelect={(item: KeyDisplayOption) => onTravelClassChange(item.key)}
          selectedKey={tripOptions.travelClass}
        />
      </Grid>
      <Grid item>
        <TravelersNumberSelector
          onAdultPassangersChange={onAdultPassangersChange}
          onChildrenPassangersChange={onChildrenPassangersChange}
          onInfantPassangersChange={onInfantPassangersChange}
          passengers={tripOptions.passengers}
        />
      </Grid>
    </Grid>
  );
}

export default TravelersSelector;
